/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFolderUnderline: {
  name: 'folder-underline';
  data: string;
} = {
  name: 'folder-underline',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 2a.5.5 0 0 1 .5-.5h3.586a.5.5 0 0 1 .353.146l1.415 1.415a1.5 1.5 0 0 0 1.06.439H14a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V2Zm7 9.5H14a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 14 2.5H8.414a.5.5 0 0 1-.353-.146L6.646.939A1.5 1.5 0 0 0 5.586.5H2A1.5 1.5 0 0 0 .5 2v8A1.5 1.5 0 0 0 2 11.5h5.5v3H3a.5.5 0 0 0 0 1h10a.5.5 0 0 0 0-1H8.5v-3Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
